import styled from 'styled-components';

export const StandardDivider = styled.hr`
  width: 100%;
  margin: 1.5rem 0;
`;
